import { useTranslation } from 'react-i18next';

export function useLanguage() {
  const { i18n } = useTranslation();

  switch (i18n.resolvedLanguage) {
    case 'ko':
      return 'ko' as const;
    case 'ja':
      return 'ja' as const;
    default:
      return 'en' as const;
  }
}
